type K = string | 0; // 0 is sentinel for null
export class L4Map<V> {
  a = new Map<string, Map<K, Map<string, Map<K, V>>>>();
  get(a: string, b: string | null, c: string, d: string | null): V | undefined {
    const bKey: K = b ?? 0,
      dKey: K = d ?? 0;
    const m2 = this.a.get(a);
    if (!m2) return;
    const m3 = m2.get(bKey);
    if (!m3) return;
    const m4 = m3.get(c);
    if (!m4) return;
    return m4.get(dKey);
  }
  set(a: string, b: string | null, c: string, d: string | null, v: V) {
    const bKey: K = b ?? 0,
      dKey: K = d ?? 0;
    let m2 = this.a.get(a);
    if (!m2) this.a.set(a, (m2 = new Map()));
    let m3 = m2.get(bKey);
    if (!m3) m2.set(bKey, (m3 = new Map()));
    let m4 = m3.get(c);
    if (!m4) m3.set(c, (m4 = new Map()));
    m4.set(dKey, v);
  }

  // return an array of [[a, b, c, d], v]
  *entries() {
    for (const [a, m2] of this.a.entries()) {
      for (const [b, m3] of m2.entries()) {
        for (const [c, m4] of m3.entries()) {
          for (const [d, v] of m4.entries()) {
            const bValue = b === 0 ? null : b;
            const dValue = d === 0 ? null : d;
            yield [[a, bValue, c, dValue], v] as [
              [string, string | null, string, string | null],
              V,
            ];
          }
        }
      }
    }
  }

  has(a: string, b: string | null, c: string, d: string | null): boolean {
    const bKey: K = b ?? 0,
      dKey: K = d ?? 0;
    const m2 = this.a.get(a);
    if (!m2) return false;
    const m3 = m2.get(bKey);
    if (!m3) return false;
    const m4 = m3.get(c);
    if (!m4) return false;
    return m4.has(dKey);
  }
}
